/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Payment data (TransactionId, PaymentDate, Amount...) of the purchase process.
 */
export interface PaymentParam { 
    /**
     * Payment transaction identifier in the payment gateway. Maximum lenght 255.
     */
    transactionId: string;
    /**
     * Payment date. Format yyyy-MM-dd HH:mm:ss
     */
    paymentDate: string;
    /**
     * Payment amount.
     */
    amount: number;
    /**
     * Payment currency code. Maximum lenght 3. Examples: EUR, GBP...
     */
    currency: string;
    /**
     * Payment status. Maximum lenght 50. Examples: Completed, Pending...
     */
    status: string;
    /**
     * Payment gateway. Maximum lenght 50. Examples: Stripe, Paypal...
     */
    gateway: string;
    /**
     * Payment receipt. Encoded in Base64 format. Maximum length 11 MB
     */
    paymentReceipt: PaymentParam.PaymentReceiptEnum;
}
export namespace PaymentParam {
    export type PaymentReceiptEnum = '[B@52d6cd34';
    export const PaymentReceiptEnum = {
        B52d6cd34: '[B@52d6cd34' as PaymentReceiptEnum
    };
}


